import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { typeOf } from '@ember/utils';
import eq from 'ember-truth-helpers/helpers/eq';
import orElse from 'volta/helpers/or-else';
import BvIcon from 'volta/components/bv-icon';
import BvBadge from 'volta/components/bv-badge';
import BvText from 'volta/components/bv-text';
import BvTooltip from 'volta/components/bv-tooltip';
import BvSpinner from 'volta/components/bv-spinner';
import type { TOC } from '@ember/component/template-only';
import type { IBvMenuItem } from 'volta/components/bv-menu';
interface BvMenuItemContentSignature {
    Args: {
        item: IBvMenuItem;
    };
    Blocks: {
        default: [];
    };
}
const BvMenuItemContentComponent: TOC<BvMenuItemContentSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  {{#if (eq (typeOf @item.icon) 'string')}}
    <BvIcon
      @glyph={{@item.icon}}
      @color={{orElse @item.iconColor @item.color}}
      class='bv-menu-item__icon'
    />
  {{else if @item.icon}}
    <span class='u-mr-2 u-d-inline-flex u-align-items-center u-justify-content-center'>
      {{@item.icon}}
    </span>
  {{/if}}
  {{#if @item.badge}}
    <BvBadge
      @color={{@item.badge.color}}
      @splitColor={{@item.badge.splitColor}}
      @text={{@item.badge.text}}
      class='bv-menu-item__icon'
    />
  {{/if}}
  {{#if @item.prefix}}
    <div class='bv-menu-item__prefix'>
      {{@item.prefix}}
    </div>
  {{/if}}
  <div class='bv-menu-item__content' data-test-menu-content='{{@item.content}}'>
    {{#if (orElse @item.content (has-block))}}
      {{#if @item.title}}
        <BvText @variant='heading-xs' @text={{@item.title}} class='u-text-upper' />
      {{/if}}
      {{#if @item.content}}
        {{@item.content}}
      {{else if (has-block)}}
        {{yield}}
      {{/if}}
    {{else}}
      {{@item.tooltip}}
    {{/if}}
  </div>
  {{#if @item.suffix}}
    {{@item.suffix}}
  {{/if}}
  {{#if @item.shortcut}}
    <span class='bv-menu-item__shortcut'>
      {{@item.shortcut}}
    </span>
  {{/if}}
  {{#if @item.hasArrow}}
    <BvIcon class='bv-menu-item__arrow' @glyph='chevron-forward' />
  {{else if @item.selected}}
    <BvIcon class='bv-menu-item__arrow' @glyph='checkmark' />
  {{/if}}
  {{#if @item.tooltip}}
    <BvTooltip @text={{@item.tooltip}} />
  {{/if}}
  {{#if @item.isLoading}}
    <BvSpinner
      class='u-position-absolute u-right-2 u-shadow-card u-border-radius u-bg-surface u-animation-appear-right u-p-1'
      @size='sm'
    />
  {{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvMenuItemContentComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvMenu::Item::Content': typeof BvMenuItemContentComponent;
        'bv-menu/item/content': typeof BvMenuItemContentComponent;
    }
}
